<!-- 表二列表 -->

<template>
	<div class="ListCage Rtable5">
		<div class="tabTtl">
		 	 <span>表 1-5：获得表彰情况登记表</span>
		 	 <div class="tabBtns">
		 	 	 <el-button size="mini" @click="goBack">返回</el-button>
				 <!-- <el-select v-model="value" clearable placeholder="历史版本列表" class="selectTime" @change="gethistory(value)">
					 <el-option
							 v-for="item in options"
							 :key="item.id"
							 :label="item.value"
							 :value="item.id">
					 </el-option>
				 </el-select> -->
		 	 </div>
		 </div>
	     <div class="ctrlsLine">
              <el-input v-model="seekPms.keyword" size="small" placeholder="通过奖项名称、颁奖单位查询"></el-input>
              <el-button class="seekBtn" @click="tabSeek('init')" size="small">查询</el-button>
         </div>
         <div class="tabArea">
			 <div class="editArea editBox">
				 <el-table :data="tabDat" border style="width: 100%" v-loading="loading">
					 <el-table-column label="序号" width="60" align="center" type="index">
						 <template slot-scope="scope">
							 {{ scope.$index + 1 + 15*(seekPms.no - 1) }}
						 </template>
					 </el-table-column>
					 <el-table-column prop="hjName" label="奖项名称" align="center">
					 </el-table-column>
					 <el-table-column label="表彰对象" align="center">
						 <template slot-scope="scope">
							 {{ scope.row.bzObject | translate('C023',dicMap,scope.row) }}
						 </template>
					 </el-table-column>
					 <el-table-column prop="commend" label="奖励内容" align="center">
					 </el-table-column>
					 <el-table-column prop="bjName" label="颁奖单位" align="center">
					 </el-table-column>
					 <el-table-column label="获奖级别" align="center">
						 <template slot-scope="scope">
							 {{ scope.row.hjLevel | translate('C024',dicMap,scope.row) }}
						 </template>
					 </el-table-column>
					 <el-table-column label="表彰时间" align="center">
						 <template slot-scope="scope">
							 {{ scope.row.hjDate }}
						 </template>
					 </el-table-column>
					 <el-table-column label="操作" width="150" align="center">
						 <template slot-scope="scope">
							 <el-button size="mini" @click="memberEdit(scope.row)" type="primary">查看</el-button>
						 </template>
					 </el-table-column>
				 </el-table>
				 <div v-show="value!==''">
					 <p v-show="value!==''" >历史版本：</p>
					 <el-table :data="historyJsonParams" border style="width: 100%" v-loading="loading">
						 <el-table-column label="序号" width="60" align="center" type="index">
							 <template slot-scope="scope">
								 {{ scope.$index + 1 + 15*(seekPms.no - 1) }}
							 </template>
						 </el-table-column>
						 <el-table-column prop="hjName" label="奖项名称" align="center">
						 </el-table-column>
						 <el-table-column label="表彰对象" align="center">
							 <template slot-scope="scope">
								 {{ scope.row.bzObject | translate('C023',dicMap,scope.row) }}
							 </template>
						 </el-table-column>
						 <el-table-column prop="commend" label="奖励内容" align="center">
						 </el-table-column>
						 <el-table-column prop="bjName" label="颁奖单位" align="center">
						 </el-table-column>
						 <el-table-column label="获奖级别" align="center">
							 <template slot-scope="scope">
								 {{ scope.row.hjLevel | translate('C024',dicMap,scope.row) }}
							 </template>
						 </el-table-column>
						 <el-table-column label="表彰时间" align="center">
							 <template slot-scope="scope">
								 {{ scope.row.hjDate }}
							 </template>
						 </el-table-column>
						 <el-table-column label="操作" width="150" align="center">
							 <template slot-scope="scope">
								 <el-button size="mini" @click="memberEdit(scope.row)" type="primary">查看</el-button>
							 </template>
						 </el-table-column>
					 </el-table>
				 </div>
			 </div>
			 <div class="headBar">
				 <span>申报人信息</span>
			 </div>
			 <div class="editArea newEditArea" :class="value!==''?'newStyle':''">
				 <div class="editBox">
					 <p class="edName">申报人：</p>
					 <div class="edInp">
						 <el-input disabled size="small" v-model="declare.personnel"></el-input>
					 </div>
				 </div>
				 <div class="editBox">
					 <p class="edName">联系方式：</p>
					 <div class="edInp">
						 <el-input disabled size="small" v-model="declare.contact"></el-input>
					 </div>
				 </div>
				 <div class="editBox">
					 <p class="edName">申报时间：</p>
					 <div class="edInp">
						 <el-input disabled size="small" v-model="updatedAt"></el-input>
					 </div>
				 </div>
			 </div>
			 <div class="editArea newEditArea" :class="value!==''?'newStyle':''" v-show="value!==''">
				 <div class="editBox">
					 <p class="edName">申报人：</p>
					 <div class="edInp">
						 <el-input disabled size="small" v-model="historyDeclare.personnel"
								   :class="historyDeclare.personnel!==declare.personnel?'highlight':''">
						 </el-input>
					 </div>
				 </div>
				 <div class="editBox">
					 <p class="edName">联系方式：</p>
					 <div class="edInp">
						 <el-input disabled size="small" v-model="historyDeclare.contact"
								   :class="historyDeclare.contact!==declare.contact?'highlight':''">
						 </el-input>
					 </div>
				 </div>
				 <div class="editBox">
					 <p class="edName">申报时间：</p>
					 <div class="edInp">
						 <el-input disabled size="small" v-model="historyDeclare.updatedAt"
								   :class="historyDeclare.updatedAt!==updatedAt?'highlight':''">
						 </el-input>
					 </div>
				 </div>
			 </div>

         </div>

		 <div class="pageCage" v-if="pgAll > 1">
			 <el-pagination
				 @current-change="pageSent"
				 :current-page='seekPms.no'
				 layout="prev, pager, next"
				 :page-count="pgAll">
			 </el-pagination>
		 </div>

	</div>
</template>

<script>
    import { tabList5,tab5Remove,tab5Clean,pSubmitHistoryList } from '@/api/pressRole/pressRole';
	import { getFileToken } from '@/api/account';
    export default{
         data(){
             return{
                 loading:false,
                 tabDat:[],
                 detArrs:[],
                 dicMap:{},
                 yearSet:0,
                 seekPms:{
                    keyword:'',
                    no:1,
                    size:15
                 },
				 pgAll:0,
				 declare:{
					 personnel:"",
					 contact:""
				 },
				 updatedAt:'',
				 historyJsonParams:[],
				 historyJson:[],
				 historyDeclare:{
					 personnel:"",
					 contact:"",
					 updatedAt:''
				 },
				 options:[],
				 value:'',
             }
         },
         filters:{
              translate:function(dat,code,transMap,rowdat){
					if(code == 'C024' && transMap[code][dat] == '其他'){
							return rowdat.hjLevelOther;
					}else{
							return transMap[code][dat];
					}
              },
              stringTrans:function(dat,code){
                  if(code == 'time'){
                      return dat.substr(0,10);
                  }
              }
         },
         methods:{
             tabSeek:function(type){
                 this.loading = true;
                 if(type == 'init'){
                    this.seekPms.no = 1;
                 }

                 tabList5(this.seekPms).then(response => {
                    let vm = this;
                    setTimeout(function(){
                        vm.tabDat = response.pCommendList;
                        vm.loading = false;
						vm.pgAll = response.totalPages;
						if(response.pOrganizationPersonnel!==null){
							vm.declare.contact = response.pOrganizationPersonnel.contact;
							vm.declare.personnel = response.pOrganizationPersonnel.personnel;
							vm.updatedAt = response.pOrganizationPersonnel.updatedAt;
						}
                    },300)
                 })
             },

             dictInit:function(){
                let nameArr = ['C023','C024'];
                let newPromise = this.$store.dispatch('dictUpdate',{codeArr:nameArr,type:'map'});
                newPromise.then(result => {
                     this.dicMap = result;
                     this.tabSeek();
                })

             },
             memberEdit:function(dat){
                 let pathParams = {
                    pressId:this.$route.query.pressId,
                    mtId:this.$route.query.mtId,
                    pressType:this.$route.query.pressType,
                 }

                 if(dat){
                    pathParams.id = dat.id;
                 }

                 this.$router.push({
                    path:'edsct_tab5',
                    query:pathParams
                 })
             },

			 pageSent:function(inx){
					this.seekPms.no = inx;
					this.tabSeek();
			 },

             goBack:function(){
                 this.$router.go(-1);
             },
			 // 获取出版单位历史提交版本列表
			 getHistoryList:function(){
				 let that = this;
				 pSubmitHistoryList({publishMaterialId:this.$route.query.mtId}).then(response => {
					 that.historyJson = response.pSubmitHistoryList;
					 for (const list of response.pSubmitHistoryList) {
						 that.options.push({'value':list.createdAt,'id':list.id})
					 }
				 })
			 },
			 // 获取出版单位历史提交json数据
			 gethistory:function(id){
				 const that = this;
				 for (const list of that.historyJson) {
					 if(id == list.id){
						 that.historyJsonParams = JSON.parse(list.afterJson);
						 that.historyDeclare =JSON.parse(list.submittor);
					 }
				 }
				 // 获取图片
				 getFileToken().then(data => {
					 that.historyImgUrl = process.env.BASE_API + '/File/File/download/token/' + data.resultStatus.token + '/id/' + that.historyJsonParams.yyzzId;
				 })
			 },
         },
		mounted(){
			this.getHistoryList();
		},
         created:function(){
             this.seekPms.publishMaterialId = this.$route.query.mtId;
             this.dictInit();
         }
    }

</script>

<style lang="scss">

    @import "src/styles/pressRoleL";
		.highlight{
			.el-input__inner,.el-textarea__inner{
				color: red!important;
			}
		}
		.Rtable5 .pageCage{
			  padding: 30px 0px;
				text-align: center;
		}
	.Rtable5{
		.editBox{
			overflow: hidden;
		}
		.newStyle{
			margin: 30px 0!important;
			width: 50%!important;
			overflow: hidden;
			float: left;
		}
		.selectTime{
			float: left;
			font-weight: normal;
			margin: -5px 30px;
		}
		.headBar {
			padding: 0px 24px;
			height: 45px;
			line-height: 45px;
			background: #F8F8F8;
			color: #666666;
			margin-top: 12px;
		}
		.newEditArea {
			width: 80%;
			margin: 0 auto;
			padding: 30px;

			.editBox {
				width: 100%;
				height: auto;
				overflow: hidden;

				p {
					float: left;
					width: 100px;
					text-align: right;
				}

				.edInp {
					width: 300px;
					float: left;
					margin: 10px;
				}
			}
		}
	}


</style>



// WEBPACK FOOTER //
// table5.vue?461197c4